import pipe from 'ramda/es/pipe'
import slice from 'ramda/es/slice'
import forEach from 'ramda/es/forEach'
import moment from 'moment/min/moment.min'
import Api from 'Ajax'
import {resultsViewModeTypes as vmTypes} from 'Shared'
import {Professions,MainCategories,SubCategories,Answer,Question,TestState,TestTemplate} from 'Models'
import AbstractPiniaModel from './AbstractPiniaModel'
import {resetVisitedBlocks} from '@features/IntroTypes/BlockIntro/model/blockintro'
import { useTestResultStore } from '../pinia/stores/testResult'
import { useAnswersStore } from '../pinia/stores/answers'
import { useViewStateStore } from '../pinia/stores/viewState'


let guardedViewModeChange = (expexted, newOne) => {
    if (TestResults.isCurrentViewModeOfType(expexted))
        TestResults.setCurrentViewModeTo(newOne);
};


export class TestResults extends AbstractPiniaModel {
    constructor(result) { super(result); }


    //#region Static Methods
        static piniaStore()                 { return useTestResultStore() }
        static getUserAnswers()             { return useAnswersStore().userAnswers.map(a=>Answer.create(a)) }
        static startTime()                  { return this.piniaStore().startTime }
        static endTime()                    { return this.piniaStore().endTime }
        static cancelled()                  { return this.piniaStore().cancelled }
        static savedToBackend()             { return this.piniaStore().savedToBackend }
        static expectedDurationInSec()      { return this.piniaStore().expectedDurationInSeconds }
        static expectedDurationInSeconds()  { return this.expectedDurationInSec() }
        static actualDurationInSeconds()
        {
            let duration = moment(this.endTime()) - moment(this.startTime())
            return moment.duration(duration).asSeconds()
        }

        //Todo: Move ResultsMode related methods to TestState!!!
        static isInResultsMode() { return TestState.isInResultsMode(); }
        static currentViewMode() { return useViewStateStore().viewMode; }

        static setExpectedDurationInSec(seconds){ this.dispatch('setExpectedDuration', seconds) }
        static setInResultsModeTo(isActive)     { useViewStateStore().changeIsResultsModeTo(isActive); }
        static setCurrentViewModeTo(viewMode)   { useViewStateStore().changeViewModeTo(viewMode); }
        static isCurrentViewModeOfType(viewMode){ return this.currentViewMode() === viewMode; }

        static initWith(data)
        {
            this.dispatch('initTestState', data)
            this.dispatch('finalizeTestState', data)
            this.dispatch('testResultsSavedToBackend')
        }
        static setCurrentViewModeToPrint()
        {
            this.setCurrentViewModeTo(vmTypes.print)
        }
        static setCurrentViewModeToMainCategories()
        {
            this.setCurrentViewModeTo(vmTypes.maincategories)
        }
        static setCurrentViewModeToSummary()
        {
            this.setCurrentViewModeTo(vmTypes.summary)
        }
        static setToPreviousResultsViewMode(includeCategoriesView)
        {
            if(includeCategoriesView) {
                guardedViewModeChange(vmTypes.subcategories, vmTypes.maincategories);
                guardedViewModeChange(vmTypes.summary, vmTypes.subcategories);
                guardedViewModeChange(vmTypes.details, vmTypes.summary);
            }
            else guardedViewModeChange(vmTypes.details, vmTypes.summary);
        }
        static setToNextResultsViewMode(includeCategoriesView)
        {
            if(includeCategoriesView) {
                guardedViewModeChange(vmTypes.summary, vmTypes.details);
                guardedViewModeChange(vmTypes.subcategories, vmTypes.summary);
                guardedViewModeChange(vmTypes.maincategories, vmTypes.subcategories);
            }
            else guardedViewModeChange(vmTypes.summary, vmTypes.details);
        }

        static resetStartTime()
        {
            this.dispatch('initTestState', {
                startTime: moment().format(),
                expectedDurationInSeconds: Question.currentQuestionsDuration()
            })
        }

        static initResultsState(isRealTest=false)
        {
            this.dispatch('initTestState', {
                startTime: moment().format(),
                expectedDurationInSeconds: Question.currentQuestionsDuration()
            })
            useAnswersStore().resetAnswers()

            this.setCurrentViewModeTo(isRealTest ? vmTypes.maincategories : vmTypes.summary)
            this.setInResultsModeTo(false)

            resetVisitedBlocks()
        }
        static finalizeResultsState(isCancelled=false, isRealTest=false)
        {
            this.dispatch('finalizeTestState', { isCancelled: isCancelled, endTime: moment().format() });
            this.setCurrentViewModeTo(isRealTest ? vmTypes.maincategories : vmTypes.summary);
            this.setInResultsModeTo(true);
        }
        static reset()
        {
            this.dispatch('resetTestResults');
            useAnswersStore().resetAnswers();

            resetVisitedBlocks()
        }

        static createResultsFor(questions)
        {
            let startIndex          = Question.selectedIndex()===0 ? 0 : (Question.selectedIndex()+1);
            let createResultsFor    = pipe(
                slice(startIndex, Question.currentQuestionsCount()),
                forEach(question => this.createResultFor(question))
            );
            createResultsFor(questions);
        }
        static createResultFor(question, index)
        {
            const fallbackMainCategoryID = MainCategories.getSelected().id()
            const fallbackSubCategoryID = SubCategories.getSelected().id()
            const questionMainCategoryID = Number(question.mainCategoryID()) || fallbackMainCategoryID
            const questionSubCategoryID = Number(question.subCategoryID()) || fallbackSubCategoryID
            const resultsSubCategoryID = Number(question.insertedFromSubCategoryID()) || questionSubCategoryID

            useAnswersStore().addToUserAnswers({
                question: question.getSource(),
                questionIndex: index,
                userInput: [],
                expectedDurationInSeconds: Number(question.duration()),
                actualDurationInSeconds: 0,
                ignored: false,
                mainCategoryID: questionMainCategoryID,
                subCategoryID: questionSubCategoryID,
                resultsSubCategoryID: resultsSubCategoryID,

                scoredPoints:           0,
                realNumOfCorrectAnswers:0,
                realNumOfWrongAnswers:  question.realQuestionsCount(),
            });
        }

        static packageAnswersForResultData(answers)
        {
            return answers.map(answer => ({
                    questionID:             answer.id(),
                    audioUuid:              answer.audioUuid(),
                    questionIndex:          answer.questionIndex(),
                    mainCategoryID:         answer.mainCategoryId(),
                    subCategoryID:          answer.subCategoryId(),
                    resultsSubCategoryID:   answer.resultsSubCategoryId(),
                    userInput:              answer.userInput(),
                    expectedDurationInSecs: answer.expectedDurationInSeconds(),
                    actualDurationInSecs:   answer.actualDurationInSeconds(),
                    ignored:                answer.ignored(),
                    isCorrect:              answer.isCorrect(),

                    scoredPoints:           answer.scoredPoints(),
                    realNumOfCorrectAnswers:answer.realNumCorrectAnswers(),
                    realNumOfWrongAnswers:  answer.realNumWrongAnswers(),
            }))
        }


        /** Safe metadata for Sentry when POST /tests/results fails (no userInput). */
        static saveDiagnosticsContext()
        {
            try {
                const d = this.packageResultDataForTransfer()
                return {
                    templateID: d.templateID,
                    professionID: d.professionID,
                    generatedTestID: d.generatedTestID ?? null,
                    cancelled: d.cancelled,
                    answerCount: (d.answers || []).length,
                }
            } catch (e) {
                return { packagingFailed: true, message: String(e?.message || e) }
            }
        }

        static packageResultDataForTransfer()
        {
            let answers = useAnswersStore().userAnswers.map(ua => Answer.create(ua))
            let correct = answers.reduce((acc,a) => acc + a.realNumCorrectAnswers(), 0);
            let wrong   = answers.reduce((acc,a) => acc + a.realNumWrongAnswers(), 0);

            const gainedPoints = Answer.userAnswers().reduce( (sum,a) => sum + a.scoredPoints(), 0 )
            const possiblePoints = Answer.userAnswers().reduce( (sum,a) => sum + a.maxPoints(), 0 )
            const gainedPercentage = possiblePoints > 0
                ? Math.round(gainedPoints * (100 / possiblePoints))
                : 0

            return {
                professionID:           Professions.getSelected().id(),
                templateID:             TestTemplate.getSelected().id(),
                generatedTestID:        TestTemplate.getSelected().generatedTestID(),
                startTime:              this.startTime(),
                endTime:                this.endTime(),
                maxDurationInSeconds:   this.expectedDurationInSec(),
                actDurationInSeconds:   this.actualDurationInSeconds(),
                cancelled:              this.cancelled(),
                correctCount:           correct,
                wrongCount:             wrong,
                answers:                this.packageAnswersForResultData(answers),
                gainedPercentage:      gainedPercentage
            }
        }

        static saveToBackend()
        {
            let onSaved     = _ => this.dispatch('testResultsSavedToBackend')
            let resultData  = this.packageResultDataForTransfer()

            return Api.postTestResultToBackend(resultData).then( onSaved )
        }
    //#region Static Methods
}
